import { noop, wrapper } from "../../types";
export const defaultProps = {
  ...wrapper,
  click: noop
};
